<template>
  <div id="app">
    <Portfolio/>
  </div>
</template>

<script>
import Portfolio from './components/Portfolio.vue'

export default {
  name: 'app',
  components: {
    Portfolio
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  a {
    &:link, &:visited {
      text-decoration: none;
      color: #aaf;
      &:hover {
        color: #ccf;
      }
    }
  }
}
</style>
